import Vue from 'vue/types'
import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios'
import { BvToast } from 'bootstrap-vue/src/components/toast'

import { AUTHORIZATION_TOKEN } from './auth/constants'

export interface CMSVueApp extends Vue {
  $bvToast: BvToast;
}

export interface ServerErrorBody {
  code: string;
  message?: string;
  reason?: string;
  resolution?: string;
}

export interface ServerErrorResponse { error: ServerErrorBody }

export interface PaginationLinks {
  next?: string;
  prev?: string;
  total?: number;
  page?: number;
  pages?: number;
}

export interface ApiHeaders {
  'Content-Type': string;
  Authorization?: string;
}

export default class Api {
  public app: CMSVueApp
  public baseURL: string
  public serverHost: string
  public http: AxiosInstance
  public baseApiPrefix = '/api'
  public headers: ApiHeaders = { 'Content-Type': 'application/json' }

  constructor (VueApp: CMSVueApp) {
    this.serverHost = 'https://app.comercializadoracms.com'
    if (
      window.location.href.includes('localhost:') ||
      window.location.href.includes('127.0.0.1:')
    ) { this.serverHost = 'http://127.0.0.1' }

    this.app = VueApp
    this.baseURL = this.serverHost + this.baseApiPrefix
    const authToken = localStorage.getItem(AUTHORIZATION_TOKEN)
    if (authToken !== null && authToken !== undefined) {
      this.headers.Authorization = authToken
    }

    this.http = axios.create({
      baseURL: this.baseURL,
      headers: this.headers,
      responseType: 'json',
      timeout: 60000
    })

    this.http.interceptors.response.use(
      this.responseInterceptor,
      this.errorInterceptor
    )
  }

  responseInterceptor = (response: AxiosResponse): AxiosResponse => {
    return response
  }
  errorInterceptor = (error: AxiosError): Promise<never> => {
    // Return simple global error if it's not a backend exception.
    // Remove the local API Token if recieves a 401 Unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem(AUTHORIZATION_TOKEN)
    }
    if (error.response?.data.error === undefined) {
      this.app.$bvToast.toast(
        error?.message, {
          title: 'Oh oh, Ha Ocurrido un Error',
          variant: 'danger',
          autoHideDelay: 5000
        }
      )
    } else {
      this.app.$bvToast.toast(
        (error.response?.data.error.reason + '\n' + error.response?.data.error.resolution), {
          title: `${error.response?.data.error.code}: ${error.response?.data.error.message}`,
          variant: 'danger',
          autoHideDelay: 5000
        }
      )
    }
    return Promise.reject(error)
  }
}
